import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./NavBar.scss";
import { motion, AnimatePresence } from "framer-motion";
import { Link, Outlet } from "react-router-dom";
import { fetchServiceTitles } from "../../Utils/utils";

import navbarLogo from "../../Assets/logo.png";

function NavBar() {
  const [services, setServices] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);

  const loadServices = useCallback(async () => {
    const data = await fetchServiceTitles();
    if (data) setServices(data);
  }, []);

  useEffect(() => {
    loadServices();
  }, [loadServices]);

  const logo = useMemo(() => {
    return (
      <img
        src={navbarLogo}
        border="0"
        alt="afriyofa-logo"
      ></img>
    );
  }, []);
  //Todos

  const serviceLinks = useMemo(() => {
    return services.length > 0
      ? services.map((service) => (
          <li onClick={() => setIsOpen(false)} key={service.id}>
            <Link to={`/services/${service.title}`}>{service.title}</Link>
          </li>
        ))
      : null;
  }, [services]);

  //handle color change on active page
  //work on the logo image

  return (
    <div>
      <div className="navbar_container">
        <nav className="navbar">
          <div className="navbar_logo">{logo}</div>
          {/* desktop */}
          <div className="navbar_links desktop-nav">
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <Link to="/about">About</Link>
              </li>
              <li>
                <Link to="/portfolio">Portfolio</Link>
              </li>

              <li className="dropdown">
                <Link to="/">Services</Link>
                <ul className="dropdown-menu">{serviceLinks}</ul>
              </li>

              <li>
                <Link to="/blog">Blog</Link>
              </li>
              <li>
                <Link to="/contact">Contact</Link>
              </li>
            </ul>
          </div>

          {/* mobile menu */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                className="mobile-menu"
                initial={{ height: 0, opacity: 0 }}
                animate={{ height: "auto", opacity: 1 }}
                exit={{ height: 0, opacity: 0 }}
                transition={{ type: "linear", stiffness: 1 }}
              >
                <ul>
                  <li>
                    <Link to="/" onClick={() => setIsOpen(false)}>
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/about" onClick={() => setIsOpen(false)}>
                      About
                    </Link>
                  </li>
                  <li>
                    <Link to="/portfolio" onClick={() => setIsOpen(false)}>
                      Portfolio
                    </Link>
                  </li>

                  {/* MOBILE SERVICES DROPDOWN */}
                  <li
                    className="mobile-dropdown"
                    onClick={() => setServiceOpen(!serviceOpen)}
                  >
                    <div className="dropdown-header">
                      Services
                      <span className={serviceOpen ? "rotate" : ""}>▾</span>
                    </div>

                    <AnimatePresence>
                      {serviceOpen && (
                        <motion.ul
                          className="mobile-dropdown-menu"
                          initial={{ height: 0, opacity: 0 }}
                          animate={{ height: "auto", opacity: 1 }}
                          exit={{ height: 0, opacity: 0 }}
                          transition={{ duration: 0.2 }}
                        >
                          {serviceLinks}
                        </motion.ul>
                      )}
                    </AnimatePresence>
                  </li>

                  <li>
                    <Link to="/blog" onClick={() => setIsOpen(false)}>
                      Blog
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact" onClick={() => setIsOpen(false)}>
                      Contact
                    </Link>
                  </li>
                </ul>
              </motion.div>
            )}
          </AnimatePresence>
          {/* hamburger */}
          <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
            <div className={`bar ${isOpen ? "open" : ""}`} />
            <div className={`bar ${isOpen ? "open" : ""}`} />
            <div className={`bar ${isOpen ? "open" : ""}`} />
          </div>
        </nav>
      </div>

      <Outlet />
    </div>
  );
}

export default React.memo(NavBar);
